import { ILifeRule } from "./ILifeRule";

export class DeadCellWithThreeNeighborsRule implements ILifeRule {
  canHandle = (isAlive: boolean): boolean => isAlive === false;

  shouldLive(numberOfNeighbors: number): boolean {
    return numberOfNeighbors === 3;
  }
}
